module.exports = __webpack_public_path__ + "img/hhbj.1392d3db.png";